import React, { Component } from 'react';
import logo from './quizhive_logo_2019.png';

export default class Logo extends Component {
  render() {
    return (
      <img src={logo} width="100%" alt="Logo for Quizhive Trivia" />
    );
  }
}
